<template>
    <div class="ccpay-security">
        <div class="ccpay-security-header">
                <span @click="back"> 返回</span>
                <span >提现验证</span>
                <span></span>
         </div>
         <div class="ccpay-security-connect">
             <form action="" v-show="userinfo">
                    <mt-field class="phoneNum phoneNumTull-lv"  placeholder="手机号" type="tel" disabled :value="'手机号：'+ userinfo.mobile"
                    ></mt-field>
                   <mt-field style="border-bottom: 1px solid #ccc;"   placeholder="请输入手机验证码"    :attr="{ 'maxlength': 6 }" type="tel"
                        class='captchaInput' v-model="code">
                        <span ref='spn' @click="getPhoneGetCaptcha()"  class="captcha">获取验证码</span>
                    </mt-field>
                    <mt-field class="phoneNum phoneNumTull-lv" disabled placeholder="邮箱号" type="tel" :value="'邮箱号：'+ userinfo.email"
                    ></mt-field>
                   <mt-field  placeholder="请输入邮箱验证码"  style="border-bottom: 1px solid #ccc;"   :attr="{ 'maxlength': 6 }" type="tel"
                        class='captchaInput' v-model="emailcode">
                        <span ref='spnemail' @click="getemailGetCaptcha()"  class="captcha">获取验证码</span>
                    </mt-field>
                    <mt-field class="passInputWord" style="border-bottom: 1px solid #ccc;"   placeholder="谷歌验证码" :attr="{ 'maxlength': 6 }" type="tel" v-model="ggcode"
                    > </mt-field>

                    <mt-button class="mt-40" size="large" type="primary" @click.prevent="submit" 
                        style='letterSpacing:5px;padding-right:0.2rem' >提现</mt-button>
                </form>
               
         </div>
    </div>
</template>

<script>
import {setCookie,setElpCookie,ccpayUser,getCookie,Formatnumbers,captchaDownTime} from '../../public/index.js'
import { Indicator } from 'mint-ui';
export default {
    data(){
        return {
            userinfo:null,
            type:'',
          
            code:'',
            emailcode:'',
            ggcode:''
        }
    },
    mounted(){
        Indicator.open();
       this.$axios.get('/v1/account/info').then(res=>{
              Indicator.close();
            if(res.code==0){
                ccpayUser(JSON.stringify(res.data),30)
                this.userinfo =   res.data
            }
        })
    },
    methods:{
         back(){
            this.$router.go(-1)
        },
        //获取手机验证码
        getPhoneGetCaptcha(){
            
            if(this.$refs.spn.innerHTML=='获取验证码'){
                this.$axios.get('/v1/verify/send_phone_code',{
                   
                }).then(res=>{
                    if(res.code==0){
                        this.$Toast('验证码已发送')
                        
                    }else{
                        this.$Toast(res.msg)
                    }
                })
                captchaDownTime(this.$refs.spn)
             }
        },
        getemailGetCaptcha(){
             if(this.$refs.spnemail.innerHTML=='获取验证码'){
                this.$axios.get('/v1/verify/send_mail_code',{
                 
                }).then(res=>{
                    if(res.code==0){
                        this.$Toast('验证码已发送')
                        
                    }else{
                        this.$Toast(res.msg)
                    }
                })
                captchaDownTime(this.$refs.spnemail)
             }
        },
        submit(){
            if(this.code==''){
                 this.$Toast('请输入手机验证码')
                 return
            }
            if(this.emailcode==''){
                 this.$Toast('请输入邮箱验证码')
                 return
            }
            if(this.ggcode==''){
                 this.$Toast('请输入谷歌验证码')
                 return
            }
             let data =   JSON.parse(window.localStorage.getItem('withdata'))
             data.validata = {
                "googleCode": this.ggcode,
                "phoneCode":this.code,
                "emailCode":this.emailcode
             }
              Indicator.open();
             this.$axios.post('/v1/wallet/withdraw',data).then(res=>{
                 Indicator.close();
                if(res.code==0){
                    this.$Toast('提现已申请')
                    this.$router.go(-1)
                }else{
                     this.$Toast(res.msg)
                }
            })
             console.log(data)
        }
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-security{
         height: 100%;;
         background: white;
        .ccpay-security-header{
              background: white;
                display: flex;
                justify-content: space-between;
                padding: 1rem;
        }
        .ccpay-security-connect{
            padding: 1rem;
            padding-right: 2rem;
            background: white;
            ul li{
                position: relative;
                padding: 1.125rem 0rem;
                color: #666;
                font-size: 0.93rem;
                border-bottom: 1px solid;
                border-color: #eee;
                span{
                    float: right;
                }
                a{
                    color: #666;
                }
            }
        }
    }
    .captcha{
        padding: 0.5rem 0.9375rem;
        background: #26a2ff;
        border-radius: 3.4375rem;
        font-size: 0.875rem;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/my/Cashaudit.vue